// Deeplink in die Afterbuy-Auktionsliste - gleiche URL wie in Orders.vue.
// Die Vorgangs-ID ist das Praefix der CustomerOrderId ("<AfterbuyOrderId>-<Index>"),
// Fallback ist die direkt gespeicherte AfterbuyOrderId (Zuordnung ohne OCC-Auftrag, z.B. FBA).
export function afterbuyOrderUrl(row) {
  let orderId = null;
  if (row && row.customerOrderId) orderId = String(row.customerOrderId).split("-")[0].trim();
  if (!orderId && row && row.afterbuyOrderId) orderId = String(row.afterbuyOrderId);
  if (!orderId) return null;
  return `https://farm04.afterbuy.de/afterbuy/auktionsliste.aspx?art=edit&id=${orderId}`;
}

// Suche in der Afterbuy-Verkaufsuebersicht per Rechnungsnummer (Kundenwunsch 18.08., P13):
// fuehrt zur Uebersichtsseite mit allen Filtermoeglichkeiten statt zum Einzelvorgang.
// Bewusst in einem neuen FENSTER zu oeffnen (P13.1) - siehe openInvoiceSearch().
export function afterbuyInvoiceSearchUrl(invoiceNumber) {
  if (!invoiceNumber) return null;
  const nr = encodeURIComponent(String(invoiceNumber).trim());
  return (
    "https://farm04.afterbuy.de/afterbuy/auktionsliste.aspx?AWebayname=&AWFilter=0&AWSuchwort=" +
    `&AWRENummer=${nr}&AWFilter2=0&awmaxart=50&maxgesamt=100&AWEmail=&AWDatumVon=&AWDatumBis=` +
    "&AWBezug=EndeDerAuktion&AWPLZ=&AWBetrag=&AWBetragBezug=1&AWStammID=&awCountryGroup=" +
    "&AWLaenderkennung=&AWLaenderkennungBezug=rechnung&AWLabelDynSearchField1=PaymentMethod&AWDynSearchField1=" +
    "&AWLabelDynSearchField2=AlterItemNumber1&AWDynSearchField2=&AWLabelDynSearchField3=ShippingAddress&AWDynSearchField3=" +
    "&AWshowall=ON&searchUserTag1=0&searchUserTag2=0&searchUserTag3=0&searchUserTag4=0&killordersession=1&art=SetAuswahl"
  );
}

// Neues Fenster statt neuer Tab - nur fuer die Rechnungsnummer-Suche (P13.1)
export function openAfterbuyInvoiceSearch(invoiceNumber) {
  const url = afterbuyInvoiceSearchUrl(invoiceNumber);
  if (url) window.open(url, "_blank", "popup=yes,width=1400,height=900");
}
